module.exports = __webpack_public_path__ + "img/no_data_active.4a2dd5ac.png";